import PropTypes from "prop-types";
import React from "react";

function SuperAdminSchoolChoice({ schools, onSelect, disabled, error }) {
  return (
    <div className="quiz-text">
      {error && (
        <div role="alert" className="alert alert-danger">
          {error}
        </div>
      )}
      <h2><strong>Wybierz szkołę</strong></h2>
      {schools.length === 0 && (
        <div className="alert alert-warning" role="status">
          Brak aktywnych szkół do wyboru.
        </div>
      )}
      <div className="row">
        {schools.map(school => (
          <div className="col-md-4 mb-2" key={school.id}>
            <button
              type="button"
              className="btn manage-button manage-red-button btn-block"
              disabled={disabled}
              data-school-id={school.id}
              onClick={() => onSelect(school)}
            >
              {school.name || school.id}
            </button>
            {school.slug && <small className="text-muted d-block mt-1">{school.slug}</small>}
          </div>
        ))}
      </div>
    </div>
  );
}

SuperAdminSchoolChoice.propTypes = {
  schools: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    slug: PropTypes.string,
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

SuperAdminSchoolChoice.defaultProps = {
  disabled: false,
  error: "",
};

export default SuperAdminSchoolChoice;
